import { render, staticRenderFns } from "./vHtml.vue?vue&type=template&id=267e0b20&scoped=true"
import script from "./vHtml.vue?vue&type=script&lang=js"
export * from "./vHtml.vue?vue&type=script&lang=js"
import style0 from "./vHtml.vue?vue&type=style&index=0&id=267e0b20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e0b20",
  null
  
)

export default component.exports